import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ScrollArea } from "@radix-ui/react-scroll-area";
import { Pill } from "lucide-react";
import { PrescriptionOrder } from "../types/prescription";
import { PrescriptionCardItem } from "./prescription-card-item";

interface PrescriptionCardProps {
  prescriptions: PrescriptionOrder[];
}

export function PrescriptionCard({ prescriptions }: PrescriptionCardProps) {
  return (
    <div className="w-full">
      <Card className="overflow-hidden">
        <CardHeader>
          <CardTitle className="text-3xl">Prescriptions</CardTitle>
          <CardDescription className="text-sm">
            All Prescription Orders
          </CardDescription>
        </CardHeader>
        <ScrollArea className="h-[calc(100%-5rem)]">
          <CardContent className="space-y-10">
            {prescriptions.map((prescription) => (
              <PrescriptionCardItem
                key={prescription.id}
                prescription={prescription}
              />
            ))}
          </CardContent>
        </ScrollArea>
      </Card>
    </div>
  );
}
